import { 
  HYK_FEE_PERCENT, 
  STRIPE_FEE_PERCENT, 
  STRIPE_FIXED_FEE, 
  VAT_PERCENT 
} from '../modules/constants/globals';

export const fromCentsToPounds = (cents) => {
  const amount = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100.0);

  return `€ ${amount}`;
};

export const formatEurFromCents = (value, locale = 'de-DE') => {
  if (value === null || value === undefined) return '—';
  const cents = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(cents)) return '—';
  return `€ ${(cents / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/** Format cents as amount string only (no currency symbol) - for use with euro icon */
export const formatCentsAmount = (cents) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format((cents ?? 0) / 100.0);
};

/** Format value already in euros (e.g. creations API) - no division */
export const formatEurosAmount = (euros) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(euros ?? 0));
};
export const calculateFullPrice = (amount) => {
  if (!amount  || amount ==0) return {totalAmount: 0,
    stripeFee: 0,
    hykFee:0}
  // Calculate individual fees
  const baseAmount = amount
  const hykFee = baseAmount * HYK_FEE_PERCENT;
  const stripeFee = baseAmount * STRIPE_FEE_PERCENT + STRIPE_FIXED_FEE;
  const subtotal = baseAmount + hykFee + stripeFee;
  const vatAmount = subtotal * VAT_PERCENT;
  const totalAmount = subtotal + vatAmount;
  console.log({amount,totalAmount: parseFloat(totalAmount).toFixed(2),
    stripeFee: baseAmount * STRIPE_FEE_PERCENT + STRIPE_FIXED_FEE,
    hykFee: baseAmount * HYK_FEE_PERCENT})
  return {
    totalAmount: parseFloat(totalAmount).toFixed(2),
    stripeFee: baseAmount * STRIPE_FEE_PERCENT + STRIPE_FIXED_FEE,
    hykFee: baseAmount * HYK_FEE_PERCENT



  };
}